/* Mumi Arte — animacion de entrada al hacer scroll.
   Si el visitante ha pedido menos animaciones, o si el navegador no soporta
   IntersectionObserver, todo se muestra de golpe: nunca se queda invisible. */
(function () {
  'use strict';

  var SELECTOR = '.mt-reveal';
  var VISIBLE = 'mt-reveal--in';
  var RED_SEGURIDAD_MS = 2500;

  function mostrarTodo() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(VISIBLE);
    });
  }

  function init() {
    var menosMovimiento =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (menosMovimiento || !('IntersectionObserver' in window)) {
      mostrarTodo();
      return;
    }

    // Red de seguridad: pase lo que pase (pestana en segundo plano, observer
    // que no dispara, error posterior), a los 2,5 s todo se ve.
    setTimeout(mostrarTodo, RED_SEGURIDAD_MS);

    var observer = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add(VISIBLE);
          observer.unobserve(entrada.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
    );

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      observer.observe(el);
    });

    // El editor de Shopify inyecta secciones sin recargar la pagina.
    document.addEventListener('shopify:section:load', function (evento) {
      evento.target.querySelectorAll(SELECTOR).forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
